class ArtistsProgressive extends HTMLElement {
  connectedCallback() {
    this._observer = null;
    this._autoEnabled = false;
    this._userExpanded = false;

    this._initial = Math.max(1, parseInt(this.dataset.initialVisible || "1", 10));
    this._batch = Math.max(1, parseInt(this.dataset.batch || "1", 10));
    this._total = Math.max(0, parseInt(this.dataset.total || "0", 10));
    this._autoAfterClick = this.dataset.auto === "true";
    this._counterTemplate = this.dataset.counterTemplate || "";

    this._rows = Array.from(this.querySelectorAll("[data-artist-row]"));
    this._counterEl = this.querySelector(".artists-footer__counter");
    this._progressBar = this.querySelector("[data-artists-progress-bar]");
    this._progressHost = this.querySelector('[role="progressbar"]');
    this._btn = this.querySelector("[data-artists-show-more]");
    this._sentinel = this.querySelector("[data-artists-sentinel]");

    this._visible = this._countVisible();

    this._btn?.addEventListener("click", () => this._onShowMoreClick());

    if (this._visible >= this._total) {
      this._finish();
    }
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  _countVisible() {
    return this._rows.filter((row) => !row.hasAttribute("hidden")).length;
  }

  _formatCounter(visible, total) {
    if (!this._counterTemplate) {
      return `${visible} of ${total}`;
    }
    return this._counterTemplate.replace("__V__", String(visible)).replace("__T__", String(total));
  }

  _updateUi(visible) {
    if (this._counterEl) {
      this._counterEl.textContent = this._formatCounter(visible, this._total);
    }
    if (this._progressBar && this._total > 0) {
      const pct = Math.round((visible * 100) / this._total);
      this._progressBar.style.width = `${pct}%`;
    }
    if (this._progressHost) {
      this._progressHost.setAttribute("aria-valuenow", String(visible));
      this._progressHost.setAttribute("aria-valuemax", String(this._total));
    }
    if (this._btn) {
      if (visible >= this._total) {
        this._btn.hidden = true;
      } else {
        this._btn.hidden = false;
      }
    }
  }

  _revealNextBatch() {
    const hiddenRows = this._rows.filter((row) => row.hasAttribute("hidden"));
    const slice = hiddenRows.slice(0, this._batch);
    for (const row of slice) {
      row.removeAttribute("hidden");
    }
    this._visible = this._countVisible();
    this._updateUi(this._visible);
    if (this._visible >= this._total) {
      this._finish();
    }
  }

  _onShowMoreClick() {
    this._userExpanded = true;
    if (this._autoAfterClick && !this._autoEnabled) {
      this._autoEnabled = true;
      this._setupObserver();
    }
    this._revealNextBatch();
  }

  _setupObserver() {
    if (!this._sentinel || this._observer || this._total <= this._visible) {
      return;
    }
    this._observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) {
          return;
        }
        if (!this._userExpanded) {
          return;
        }
        this._revealNextBatch();
        if (this._visible >= this._total) {
          this._observer?.disconnect();
          this._observer = null;
        }
      },
      { rootMargin: "200px 0px 200px 0px" }
    );
    this._observer.observe(this._sentinel);
  }

  _finish() {
    this._observer?.disconnect();
    this._observer = null;
  }
}

if (!customElements.get("artists-progressive")) {
  customElements.define("artists-progressive", ArtistsProgressive);
}
